import { Component, OnInit } from '@angular/core';
import { Product } from '../products/product';
import { ProductsService } from '../products/products.service';
import { ActivatedRoute } from '@angular/router';
import {PageEvent} from '@angular/material';
import { ControlsService } from '../controls.service';
import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { map, switchMap, publish, tap, take, defaultIfEmpty } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { Query } from '../products/query';
import { takeWhile } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigurationService } from '../configuration.service';
import { Configuration } from '../configuration';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ResolveStart,
  ResolveEnd
} from "@angular/router";

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {
    // MatPaginator Inputs
    length = 100;
    pageSize = 100;
    pageSizeOptions = [5, 10, 25, 100];
    // MatPaginator Output
    pageEvent: PageEvent;
    paginationSearchSubject: BehaviorSubject<PageEvent> =  new BehaviorSubject<PageEvent>({pageIndex:1, pageSize:100, length:100});
    config: Configuration;
    products:Product[] = [];
  dataLoading: boolean = true;


  constructor(
    private productsService:ProductsService,
    private route: ActivatedRoute,
    private cs: ControlsService,
    private configurationService: ConfigurationService,
    private router: Router
  ) {
    this.config = configurationService.getConfigurationCache();
  }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      // if navigation event has started
      if (val instanceof NavigationStart) {
        this.dataLoading = true;
      }
      // if navigation has resolved
      if (val instanceof ResolveEnd) {
        this.dataLoading = false;
      }
    });

    this.route.data
    .subscribe((data: any) => {

      this.products = (Array.isArray(data.searchResults.data))? data.searchResults.data
        .filter(item => (item.hasOwnProperty('category_name') ? false : true)) : [data.searchResults.data];
        this.dataLoading = false;
    });




  }


}




// WEBPACK FOOTER //
// ./src/app/search-results/search-results.component.ts